<template>
  <div>
   <!-- <div class="table-title">
      <p class="table-name">审核任务</p>
    </div>-->
    <a-card style="margin: 10px 0">
      <div class="filter-section">
        <!-- <span>状态:</span>
        <a-select
          style="width: 140px"
          v-model:value="form.state"
        >
          <a-select-option key="全部" value="" title="全部">
            全部
          </a-select-option>
          <a-select-option key="未拆分">
            未拆分
          </a-select-option>
          <a-select-option key="已拆分">
            已拆分
          </a-select-option>
          <a-select-option key="未分配">
            未分配
          </a-select-option>
          <a-select-option key="已分配">
            已分配
          </a-select-option>
          <a-select-option key="标注中">
            标注中
          </a-select-option>
          <a-select-option key="审核中">
            审核中
          </a-select-option>
          <a-select-option key="已完成">
            已完成
          </a-select-option>
        </a-select> -->
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item label="状态" name="state">
            <a-select
              style="width: 140px"
              v-model:value="form.state"
            >
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option v-for="value in labelState" :key="value">
                {{ value }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="名称" name="name">
            <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.name" autocomplete="off">
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData()">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:taskType="{ text }">
          {{ getTaskName(text) }}
        </template>
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:pgress="{ text }">
          {{ getValue(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:finishTime="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="toDetail(record)">详情</a>
          </span>
          <span class="gap-btn">
            <a :class="record.state == 'under_approval'?'':'grey'" @click="handleAudit(record)">审核</a>
          </span>
          <span class="gap-btn">
            <a @click="handleSubmit(record)">提交</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <audit-detail ref="auditDetail" :current-item="currentItem" :addition="addition"></audit-detail>
    <AuditDialog ref="auditDialog"></AuditDialog>
  </div>
</template>
<script>
// import { SearchOutlined } from '@ant-design/icons-vue'
import { getMyRelease, updateTask } from '@/api/task'
import { getDateTime, getTaskName, getValue, getUserName } from '@/filters'
import config from '@/config'
import AuditDetail from './AuditDetail'
// import AuditDialog from './AuditDialog'
import { getAllData } from '@/api/dataSet'
const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'taskTypeId',
    slots: { customRender: 'taskType' }
  },
  {
    title: '说明',
    dataIndex: 'description'
  },
  {
    title: '状态',
    dataIndex: 'state'
  },
  {
    title: '审核进度',
    dataIndex: 'progress',
    slots: { customRender: 'pgress' }
  },
  {
    title: '发布人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '要求完成时间',
    dataIndex: 'planFinishTime',
    slots: { customRender: 'finishTime' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    AuditDetail
    // SearchOutlined
    // AuditDialog
  },
  data () {
    return {
      labelState: config.labelState,
      form: {
        state: '',
        name: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      currentItem: {},
      addition: '',
      dataList: []
    }
  },
  mounted () {
    this.getData(1)
    this.getDataSetByPage(1)
  },
  methods: {
    getDateTime,
    getTaskName,
    getValue,
    getUserName,
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getMyRelease({ ...this.form, ...this.page, parentId: 'notNullValue', field: 'createTime', order: 'desc' }).then(res => {
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
      })
    },
    getDataSetByPage () {
      getAllData({ pageSize: 10000 }).then(res => {
        const data = res.data.map.data
        this.dataList = data.rows
      })
    },
    // 数据处理
    dataProcess (raw) {
      return raw.map(i => ({ ...i, ...i.labourAssignRecord }))
    },
    // 审核
    handleAudit (item) {
      this.$refs.auditDialog.open()
    },
    // 提交
    handleSubmit (item) {
      this.$confirm({
        title: '任务提交',
        content: '确认任务已完成，并提交？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          updateTask({
            id: item.id, state: 'approval'
          }).then(res => {
            this.$message.success('操作成功')
            this.getData(1)
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    toDetail (item) {
      this.currentItem = item
      const info = this.dataList.find(item => item.id === this.currentItem.datasetId)
      this.addition = info.addition
      this.$refs.auditDetail.open()
      // this.$router.push({ name: 'groupTaskDetail' })
    }
  }
}
</script>
<style>

</style>
